import React from 'react'

interface SubscribePopupProps {
    ShowHidePopup: Function;
    ClosePopup?: Function;
    OnApprove?: Function;
    approveBtnTitle?: string;
    messageTitle?: string;
    messageContent: string;
    
}

const SubscribePopup:React.FC<SubscribePopupProps> = ({
    ShowHidePopup,
    ClosePopup,
    OnApprove,
    approveBtnTitle,
    messageTitle,
    messageContent,
}) => {

    const closePopup = (status?: string)=>{
        if (ClosePopup) {
            ClosePopup(status);  
         }
    }

    const approve = () => {
        if (OnApprove) {
            OnApprove();
            closePopup();
        }
    }
  return (
    <div className="popup-wrapper small-warning">
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e:any)=>closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {messageTitle}
                        </div>
                    </div>
                    <div className="popup-body">
                        {messageContent}
                    </div>
                    <div className="popup-footer">
                        {
                            OnApprove ? 
                            (<>
                            
                            <button className="button blue blue-border" onClick={(e: any) => approve()}>
                                {approveBtnTitle ? approveBtnTitle : 'המשך'}
                            </button>
                            </>) 
                            :
                            (<></>)
                        }
                        <button className="button white blue-border"  onClick={(e:any)=>closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>
  )
}

export default SubscribePopup